// extracted by mini-css-extract-plugin
export default {"InputPhone":"InputPhone_InputPhone__a0bCf","InputPhone__label":"InputPhone_InputPhone__label__ch0kF","InputPhone__field":"InputPhone_InputPhone__field__JtrF-"};